import { SectionHead } from "@/components/site/SectionHead";
import { Reveal } from "@/components/site/Reveal";

const mounts = [
  {
    id: "flush",
    label: "Flush Mount Install",
    img: "/assets/flush.webp",
    alt: "CAD line drawing of a flush mount install: two square tubing rails stop at the post face on both sides, joined by one Part 200 bracket screwed to the post",
    title: "Flush mount",
    body: "Rails butt into the post on both sides and finish level with its face. One bracket makes the connection from both directions.",
    best: (
      <>
        Best for <b>a clean face line</b> — entries, front runs, anywhere the fence is looked at head-on.
      </>
    ),
  },
  {
    id: "bypass",
    label: "Bypass Mount Install",
    img: "/assets/bypass.webp",
    alt: "CAD line drawing of a bypass mount install: one unbroken square tubing rail runs past the face of the post, held by the Part 200 bracket",
    title: "Bypass mount",
    body: "One unbroken rail runs past the face of the post. Fewer joints in the run, and the rail length does the work.",
    best: (
      <>
        Best for <b>long straight runs</b> — pasture line, property line.
      </>
    ),
  },
];

export const Mounts = () => (
  <section className="section" data-testid="mounts-section">
    <div className="wrap">
      <SectionHead
        num="03"
        eyebrow="Two ways to mount"
        title="The same bracket does flush and bypass."
      />
      <div className="mounts">
        {mounts.map((m, i) => (
          <Reveal key={m.id} delay={i * 0.12}>
            <div className="draw-card" data-testid={`mount-card-${m.id}`}>
              <div className="draw-card-head">
                <b>{m.label}</b>
                <span>Part 200</span>
              </div>
              <img src={m.img} alt={m.alt} loading="lazy" width="1110" height="780" />
              <div className="mount-body">
                <h3>{m.title}</h3>
                <p>{m.body}</p>
                <div className="mount-best">{m.best}</div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
